
@if (isLoading) {
  <app-loader></app-loader>
} @else if (dataSource.data.length > 0) {
  <div class="user-property-list-table-container">
  <div class="mat-elevation-z8 hide-on-mobile">
    
    <mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="user">
          <mat-header-cell *matHeaderCellDef mat-sort-header> User </mat-header-cell>
          <mat-cell *matCellDef="let form"> 
            {{ form.userName || form.userId || '' }} 
          </mat-cell>
        </ng-container>
        
        <ng-container matColumnDef="agent">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Referred By Agent ID </mat-header-cell>
            <mat-cell *matCellDef="let form"> {{ form.agentId ?? '' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="url">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Document </mat-header-cell>
          <mat-cell *matCellDef="let form">
            <ng-container *ngIf="form.formUrl as url; else noLink">
              <a [href]="url" target="_blank" rel="noopener noreferrer">
                View / Download
                <mat-icon inline="true" aria-hidden="false" aria-label="open in new tab">open_in_new</mat-icon>
              </a>
            </ng-container>
            <ng-template #noLink>
              <span *ngIf="form.formUrl" class="text-muted">No presigned link available</span>
              <span *ngIf="!form.formUrl" class="text-muted">—</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastUpdated">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Last Updated </mat-header-cell>
            <mat-cell *matCellDef="let form"> {{ form.updatedAt ?? '' | date: 'MMMM dd, yyyy'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
            <mat-cell *matCellDef="let form"> 
              @if(form.formStatus === 'Review') {
                <button mat-raised-button color="primary" (click)="approve(form.id)">
                  <mat-icon>check</mat-icon>
                  Approve
                </button>
              } @else {
                {{ form.formStatus ?? '' }} 
              }
            </mat-cell>
        </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    
  </div>

  <div class="mobile-property-list show-on-mobile" *ngIf="!isLoading">
    <mat-card *ngFor="let form of dataSource.connect() | async" class="mobile-property-card">
      <mat-card-header>
        <!-- <div mat-card-avatar>
          <mat-icon [class.success]="property.isPublished" [class.error]="!property.isPublished">
            {{ property.isPublished ? 'check_circle' : 'cancel' }}
          </mat-icon>
        </div> -->
        <mat-card-title>{{ form.userName || '' }} </mat-card-title>
        <!-- <mat-card-subtitle>{{ property.address.city }}, {{ property.address.state }} {{ property.address.zipCode }}</mat-card-subtitle> -->
      </mat-card-header>
      <mat-card-content style="text-align: left">
        <div *ngIf="form.agentId">Referred By: {{ form.agentId ?? '' }}</div>
        <div *ngIf="form.formUrl">
          <a [href]="form.formUrl" target="_blank" rel="noopener noreferrer">
            View / Download
            <mat-icon inline="true" aria-hidden="false" aria-label="open in new tab">open_in_new</mat-icon>
          </a>
        </div>
        <div>Last Updated: {{ form.updatedAt ?? '' | date: 'MMMM dd, yyyy'}}</div>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-flat-button type="button" class="metallic-text-btn-green" (click)="openForm(form.id)">
          View / Download
            <mat-icon inline="true" aria-hidden="false" aria-label="open in new tab">open_in_new</mat-icon>
        </button>
        @if(form.formStatus === 'Review') {
          <button mat-flat-button type="button" class="metallic-text-btn-blue" (click)="approve(form.id)">
            <mat-icon>check</mat-icon>
            Approve
          </button>
        } @else if (form.formStatus === 'Approved') {
          <span class="status-approved"><i class="fa-solid fa-check success"></i> {{ form.formStatus ?? '' }}</span>
        } @else {
          {{ form.formStatus ?? '' }}
        }
        <!-- <button mat-icon-button (click)="editPricing(property)"><mat-icon>price_change</mat-icon></button>
        <button mat-icon-button (click)="manageBooking(property)"><mat-icon>edit_calendar</mat-icon></button>
        <button mat-icon-button [routerLink]="['/property', property.id, 'edit']"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button (click)="viewProperty(property)"><mat-icon>preview</mat-icon></button> -->
      </mat-card-actions>
    </mat-card>
  </div>
  <mat-paginator 
      #paginator
      [pageSizeOptions]="[5,10, 25, 100]"
      aria-label="Select page of forms">
    </mat-paginator>
  </div>
} @else {
  <p>No W9 forms found</p>
}